namespace TabAurous.ProductDevelopment {
    export interface CustomerRequirementStoneItemsForm {
        TransDetailId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
    }

    export class CustomerRequirementStoneItemsForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.CustomerRequirementStoneItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomerRequirementStoneItemsForm.init)  {
                CustomerRequirementStoneItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = WeightEditor;

                Q.initFormType(CustomerRequirementStoneItemsForm, [
                    'TransDetailId', w0,
                    'TransItemId', w0,
                    'VoucherTypeId', w1,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'ProductTypeId', w2,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'AttributeId', w0,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w2,
                    'Pieces', w1,
                    'Weight', w5
                ]);
            }
        }
    }
}
